/// <reference path="../../definitions/jquery/index.d.ts" />
/// <reference path="../../public/irep.ts" />

declare var irep: IREP.IREP;

namespace IREP {
    "use strict";

    export interface IPasswordValidation {
        success: boolean;
        message: string;
    }

    export class PasswordProcessor {
        constructor() {
            throw new Error('Static Class, cannot new this class');
        }

        // Local Ids for password validation messages
        public static PASSWORD_VALIDATION_MESSAGES = {
            SUCCESS: 'success',
            INVALID_CURRENT_PASSWORD: 'incorrect_password',
            INVALID_PASSWORD: 'invalid_password',
            PASSWORD_CONFIRM_MISMATCH: 'password_mismatch'
        }

        public static validatePassword(password: string, confirmPassword: string): IPasswordValidation {
            let isValid = {
                success: false,
                message: PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.INVALID_PASSWORD
            };

            //Logic to test that at least three of these four need to be true
            if (this.checkPasswordRequirements(password)) {
                if (!PasswordProcessor.checkPasswordAndConfirmMatch(password, confirmPassword)) {
                    isValid.success = false;
                    isValid.message = PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.PASSWORD_CONFIRM_MISMATCH;
                } else {
                    isValid.success = true;
                    isValid.message = PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.SUCCESS
                }
            }

            return isValid;
        }

        public static requirementsReport(password: string) {
            let upper = new RegExp("[A-Z]").test(password);
            let lower = new RegExp("[a-z]").test(password);
            let number = new RegExp("[0-9]").test(password);
            let special = new RegExp("[^A-Za-z0-9]").test(password);

            if (password.length >= 6) {
                $(".reqLength").removeClass("has-error");
                $(".reqLength").removeClass("unchecked");
                $(".reqLength").addClass("checkbox");
                $(".reqLength").addClass("checked");
                $(".requiredLength").removeClass("unchecked");
                //EditProfile Id
                $("#reqlength").prop("checked", true);
            }
            else {
                $(".reqLength").removeClass("checkbox");
                $(".reqLength").removeClass("checked");
                $(".requiredLength").addClass("unchecked");
                $("#reqlength").prop("checked", false);
            }

            if (upper) {
                $(".reqCapital").removeClass("unchecked");
                $("#reqCapital").prop("checked", true);
            }
            else {
                $(".reqCapital").addClass("unchecked");
                $("#reqCapital").prop("checked", false);
            }
            if (lower) {
                $(".reqLower").removeClass("unchecked");
                $("#reqLower").prop("checked", true);
            }
            else {
                $(".reqLower").addClass("unchecked");
                $("#reqLower").prop("checked", false);
            }
            if (number) {
                $(".reqNumber").removeClass("unchecked");
                $("#reqNumber").prop("checked", true);
            }
            else {
                $(".reqNumber").addClass("unchecked");
                $("#reqNumber").prop("checked", false);
            }
            if (special) {
                $(".reqSpecial").removeClass("unchecked");
                $("#reqSpecial").prop("checked", true);
            }
            else {
                $(".reqSpecial").addClass("unchecked");
                $("#reqSpecial").prop("checked", false);
            }            
            if (!([upper, lower, number, special].filter(function (e) { return e == true }).length >= 3))
                $("#passRules").addClass("has-error");
            else
                $("#passRules").removeClass("has-error");
        }

        public static checkPasswordRequirements(password: string): boolean {
            //Must be at least 6 characters long and match 3 of 4 categories: Capital Letter, lowercase letter, number, and special character 
            let upper = new RegExp("[A-Z]").test(password);
            let lower = new RegExp("[a-z]").test(password);
            let number = new RegExp("[0-9]").test(password);
            let special = new RegExp("[^A-Za-z0-9]").test(password);

            if (password.length < 6) {
                $(".reqLength").removeClass("checkbox");
                $(".reqLength").removeClass("unchecked");
                $(".reqLength").removeClass("checked");
                $(".reqLength").addClass("has-error");
            }
            
            //Logic to test that at least three of these four need to be true
            return ([upper, lower, number, special].filter(function (e) { return e == true }).length >= 3 && password.length >= 6);
        }

        public static changePassword(currentPassword: string, password: string, confirmPassword: string): JQueryDeferred<any> {
            // Create a deferred object
            let deferred = $.Deferred();

            // Make sure the password is valid
            let isValid = PasswordProcessor.validatePassword(password, confirmPassword);
            if (isValid.success) {
                // Attempt to change the password.
                irep.callApi({
                    url: '/account/changepassword',
                    type: 'POST',
                    data: {
                        OldPassword: currentPassword,
                        NewPassword: password
                    },
                    secure: true
                })
                    .done((data) => {
                        // If password did change resolve with a happy message
                        // Otherwise reject 
                        data.passwordChanged === 1 ? deferred.resolve({ success: true, message: PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.SUCCESS })
                            : deferred.reject({ success: false, message: PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.INVALID_CURRENT_PASSWORD });
                    })
                    .fail((data) => {
                        // Looking at the service, not sure why we would actually get in here. Probably a server error in which case this message
                        // is the least of your worries.
                        deferred.reject({ success: false, message: PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.INVALID_PASSWORD });
                    });
            } else {
                // Reject if the passwords don't match.
                deferred.reject(isValid);
            }

            return deferred;
        }

        public static changePasswordNoClr(currentPassword: string, password: string, confirmPassword: string): JQueryDeferred<any> {
            // Create a deferred object
            let deferred = $.Deferred();

            // Make sure the password is valid
            let isValid = PasswordProcessor.validatePassword(password, confirmPassword);
            if (isValid.success) {
                // Attempt to change the password.
                irep.callApi({
                    url: '/changepasswordnoclr',
                    type: 'POST',
                    data: {
                        OldPassword: currentPassword,
                        NewPassword: password
                    },
                    secure: true
                })
                    .done((data) => {
                        // If password did change resolve with a happy message
                        // Otherwise reject 
                        data.passwordChanged === 1 ? deferred.resolve({ success: true, message: PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.SUCCESS })
                            : deferred.reject({ success: false, message: PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.INVALID_CURRENT_PASSWORD });
                    })
                    .fail((data) => {
                        // Looking at the service, not sure why we would actually get in here. Probably a server error in which case this message
                        // is the least of your worries.
                        deferred.reject({ success: false, message: PasswordProcessor.PASSWORD_VALIDATION_MESSAGES.INVALID_PASSWORD });
                    });
            } else {
                // Reject if the passwords don't match.
                deferred.reject(isValid);
            }

            return deferred;
        }

        public static checkPasswordAndConfirmMatch(password: string, confirmPassword: string): boolean {
            return (password.trim() === confirmPassword.trim());
        }
    }
}